/**
 * Takes a nested JSON structure and flattens it to be used by react-intl
 * source: https://github.com/yahoo/react-intl/issues/193#issuecomment-152019363
 * @param {Object} nestedMessages JSON object of translations
 * @param {String} prefix optional prefix (e.g. 'dm-spu-notifications')
 */
export default function normalizeLocaleData(nestedMessages) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object.keys(nestedMessages).reduce(function (messages, key) {
    var value = nestedMessages[key];
    var prefixedKey = prefix ? "".concat(prefix, ".").concat(key) : key;
    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, normalizeLocaleData(value, prefixedKey));
    }
    return messages;
  }, {});
}